import {
  accessControlURL,
  camerasURL,
} from '../ExternalAccountsSettings/constants';

import {
  accessCardBreadcrumbs,
  accessPointBreadcrumbs,
  amenityBreadcrumbs,
  amenityReservationBreadcrumbs,
  buildingBreadcrumbs,
  cameraBreadcrumbs,
  communityBreadcrumbs,
  deliveryTypesBreadcrumbs,
  doorBreadcrumbs,
  eventBreadcrumbs,
  externalAccountBreadcrumbs,
  personBreadcrumbs,
  personSearchBreadcrumbs,
  pmcBreadcrumbs,
  residentBreadcrumbs,
  serviceRequestBreadcrumbs,
  unitBreadcrumbs,
  visitorBreadcrumbs,
  visitorUpdateBreadcrumbs,
} from './DynamicBreadcrumbs';

export const getRoutes = (t) => [
  { path: '/pmcs', breadcrumb: t('pmcSettings.pmc') },
  { path: '/pmc/create', breadcrumb: t('pmcSettings.createPmc') },
  { path: '/pmc/:pmcId', breadcrumb: pmcBreadcrumbs },
  { path: '/pmc/:pmcId/buildings', breadcrumb: t('title.buildings') },
  { path: '/pmc/:pmcId/staff', breadcrumb: t('title.staff') },
  { path: '/pmc/:pmcId/staff/create', breadcrumb: t('actions.create') },
  { path: '/pmc/:pmcId/staff/:personId', breadcrumb: personBreadcrumbs },
  {
    path: '/pmc/:pmcId/all-doors-and-cameras/camera-history',
    breadcrumb: t('camera.cameraHistory'),
  },
  {
    path: '/pmc/:pmcId/all-doors-and-cameras',
    breadcrumb: t('title.doorsAndCameras'),
  },
  { path: '/pmc/:pmcId/messages', breadcrumb: t('title.messages') },
  { path: '/pmc/:pmcId/deliveries', breadcrumb: t('title.deliveries') },
  {
    path: '/pmc/:pmcId/service-requests',
    breadcrumb: t('title.serviceRequests'),
  },
  {
    path: '/pmc/:pmcId/settings/visitors',
    breadcrumb: t('title.visitorSettings'),
  },
  {
    path: '/pmc/:pmcId/settings/deliveries',
    breadcrumb: t('title.deliveryTypes'),
  },
  {
    path: '/pmc/:pmcId/settings/branding',
    breadcrumb: t('pmc.brandingSettings'),
  },
  {
    path: '/pmc/:pmcId/settings/src',
    breadcrumb: t('serviceRequest.srCategories'),
  },
  {
    path: '/pmc/:pmcId/settings',
    breadcrumb: t('title.settings'),
  },
  {
    path: '/pmc/:pmcId/remote-doorman-notifications/leasing-inquiries',
    breadcrumb: t('title.leasingInquiries'),
  },
  {
    path: '/pmc/:pmcId/remote-doorman-notifications/courier-error-reports',
    breadcrumb: t('title.courierErrorReports'),
  },
  {
    path: '/pmc/:pmcId/remote-doorman-notifications',
    breadcrumb: t('title.remoteDoormanNotifications'),
  },
  {
    path: '/pmc/:pmcId/statistics',
    breadcrumb: t('title.statistics'),
  },
  {
    path: '/pmc/:pmcId/visitors/manage/create-visitor',
    breadcrumb: t('visitor.createVisitor'),
  },
  {
    path: '/pmc/:pmcId/visitors/manage/create-broker',
    breadcrumb: t('broker.createBroker'),
  },
  { path: '/pmc/:pmcId/visitors', breadcrumb: t('title.visitorManagement') },
  {
    path: '/pmc/:pmcId/document-library',
    breadcrumb: t('title.documentLibrary'),
  },
  {
    path: '/pmc/:pmcId/amenity/management/info/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/pmc/:pmcId/amenity/management/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/pmc/:pmcId/amenity/reservations/:id',
    breadcrumb: amenityReservationBreadcrumbs,
  },
  { path: '/pmc/:pmcId/amenity', breadcrumb: t('title.amenityReservations') },
  { path: '/pmc/:pmcId/update', breadcrumb: t('title.details') },
  {
    path: '/pmc/:pmcId/leasing-inquiries',
    breadcrumb: t('title.leasingInquiries'),
  },
  { path: '/buildings', breadcrumb: t('title.buildings') },
  { path: '/building/create', breadcrumb: t('building.createBuilding') },
  { path: '/building/:buildingId', breadcrumb: buildingBreadcrumbs },
  {
    path: '/building/:buildingId/all-doors-and-cameras/camera-history',
    breadcrumb: t('camera.cameraHistory'),
  },
  {
    path: '/building/:buildingId/all-doors-and-cameras',
    breadcrumb: t('title.doorsAndCameras'),
  },
  {
    path: '/building/:buildingId/access-points',
    breadcrumb: t('title.accessPoints'),
  },
  {
    path: '/building/:buildingId/entry-log',
    breadcrumb: t('title.entryLog'),
  },
  {
    path: '/building/:buildingId/service-requests',
    breadcrumb: t('title.serviceRequests'),
  },
  {
    path: '/building/:buildingId/deliveries',
    breadcrumb: t('title.deliveries'),
  },
  {
    path: '/building/:buildingId/service-request-categories',
    breadcrumb: t('serviceRequest.srCategories'),
  },
  {
    path: '/building/:buildingId/document-library',
    breadcrumb: t('title.documentLibrary'),
  },
  {
    path: '/building/:buildingId/update',
    breadcrumb: t('title.details'),
  },
  { path: '/building/:buildingId/staff', breadcrumb: t('title.staff') },
  {
    path: '/building/:buildingId/staff/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/building/:buildingId/staff/:personId',
    breadcrumb: personBreadcrumbs,
  },
  {
    path: '/building/:buildingId/residents',
    breadcrumb: t('title.residents'),
  },
  {
    path: '/building/:buildingId/residents/import',
    breadcrumb: t('actions.import'),
  },
  {
    path: '/building/:buildingId/residents/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/building/:buildingId/residents/create-in-unit/:unitId',
    breadcrumb: unitBreadcrumbs,
  },
  {
    path: '/building/:buildingId/residents/:personId/activity',
    breadcrumb: t('title.activity'),
  },
  {
    path: '/building/:buildingId/residents/:personId/roles',
    breadcrumb: t('title.manageRoles'),
  },
  {
    path: '/building/:buildingId/residents/:personId',
    breadcrumb: residentBreadcrumbs,
  },
  {
    path: '/building/:buildingId/units',
    breadcrumb: t('title.units'),
  },
  {
    path: '/building/:buildingId/units/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/building/:buildingId/units/:unitId',
    breadcrumb: unitBreadcrumbs,
  },
  {
    path: '/building/:buildingId/cameras',
    breadcrumb: t('title.cameras'),
  },
  {
    path: '/building/:buildingId/cameras/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/building/:buildingId/cameras/:cameraId',
    breadcrumb: cameraBreadcrumbs,
  },
  {
    path: '/building/:buildingId/access-points/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/building/:buildingId/access-points/:accessPointId',
    breadcrumb: accessPointBreadcrumbs,
  },
  {
    path: '/building/:buildingId/doors',
    breadcrumb: t('title.doors'),
  },
  {
    path: '/building/:buildingId/doors/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/building/:buildingId/doors/:doorId',
    breadcrumb: doorBreadcrumbs,
  },
  {
    path: '/building/:buildingId/visitors/manage/create-visitor',
    breadcrumb: t('visitor.createVisitor'),
  },
  {
    path: '/building/:buildingId/visitors/manage/create-broker',
    breadcrumb: t('broker.createBroker'),
  },
  {
    path: '/building/:buildingId/amenity/management/info/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/building/:buildingId/amenity/management/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/building/:buildingId/amenity/reservations/:id',
    breadcrumb: amenityReservationBreadcrumbs,
  },
  {
    path: '/building/:buildingId/amenity',
    breadcrumb: t('title.amenityReservations'),
  },
  {
    path: '/building/:buildingId/remote-doorman-notifications',
    breadcrumb: t('title.remoteDoormanNotifications'),
  },
  {
    path: '/building/:buildingId/remote-doorman-notifications/leasing-inquiries',
    breadcrumb: t('title.leasingInquiries'),
  },
  {
    path: '/building/:buildingId/remote-doorman-notifications/courier-error-reports',
    breadcrumb: t('title.courierErrorReports'),
  },
  {
    path: '/building/:buildingId/visitors',
    breadcrumb: t('title.visitorManagement'),
  },
  {
    path: '/building/:buildingId/building-operations',
    breadcrumb: t('title.buildingOperations'),
  },
  {
    path: '/building/:buildingId/front-desk',
    breadcrumb: t('frontDesk.dashboard'),
  },
  {
    path: '/building/:buildingId/home-feed/create',
    breadcrumb: t('actions.createCard'),
  },
  {
    path: '/building/:buildingId/home-feed/:cardId',
    breadcrumb: t('actions.updateCard'),
  },
  {
    path: '/building/:buildingId/home-feed',
    breadcrumb: t('title.homeFeed'),
  },
  {
    path: '/building/:buildingId/building-guide/create',
    breadcrumb: t('actions.createCard'),
  },
  {
    path: '/building/:buildingId/building-guide/:cardId',
    breadcrumb: t('actions.updateCard'),
  },
  {
    path: '/building/:buildingId/building-guide',
    breadcrumb: t('title.buildingGuide'),
  },
  {
    path: '/building/:buildingId/your-wellbeing/create',
    breadcrumb: t('actions.createCard'),
  },
  {
    path: '/building/:buildingId/your-wellbeing/:cardId',
    breadcrumb: t('actions.updateCard'),
  },
  {
    path: '/building/:buildingId/your-wellbeing',
    breadcrumb: t('title.yourWellbeing'),
  },
  {
    path: '/building/:buildingId/settings',
    breadcrumb: t('title.settings'),
  },
  {
    path: '/building/:buildingId/settings/accounts/accounting-account/yardi-file-import/:type',
    breadcrumb: t('title.yardi'),
  },
  {
    path: '/building/:buildingId/settings/accounts/accounting-account/yardi/:id/:type',
    breadcrumb: t('title.yardi'),
  },
  {
    path: '/building/:buildingId/settings/accounts/:type/:provider/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/building/:buildingId/statistics',
    breadcrumb: t('title.statistics'),
  },
  {
    path: '/global-person-search/profile',
    breadcrumb: t('globalSearch.profile'),
  },
  {
    path: '/global-person-search/create',
    breadcrumb: t('actions.addAdmin'),
  },
  {
    path: '/global-person-search/:personId',
    breadcrumb: personSearchBreadcrumbs,
  },
  {
    path: '/global-person-search',
    breadcrumb: t('title.globalPersonSearch'),
  },
  {
    path: '/ip-management/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/ip-management',
    breadcrumb: t('title.ipManagement'),
  },
  {
    path: '/carson-activity/:personId',
    breadcrumb: personBreadcrumbs,
  },
  {
    path: '/carson-activity',
    breadcrumb: t('title.carsonActivity'),
  },
  {
    path: '/access-points',
    breadcrumb: t('title.accessPoints'),
  },
  {
    path: '/service-requests',
    breadcrumb: t('title.serviceRequests'),
  },
  {
    path: '/service-requests/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/service-requests/:serviceRequestId',
    breadcrumb: serviceRequestBreadcrumbs,
  },
  {
    path: '/visitors/manage/update-visitor/:visitorId',
    breadcrumb: visitorBreadcrumbs,
  },
  {
    path: '/visitors/manage/update-broker/:personId',
    breadcrumb: visitorUpdateBreadcrumbs,
  },
  {
    path: '/visitors/manage/update-prospective-tenant/:visitorId',
    breadcrumb: visitorBreadcrumbs,
  },
  {
    path: '/visitors/manage/create-visitor',
    breadcrumb: t('visitor.createVisitor'),
  },
  {
    path: '/visitors/manage/create-broker',
    breadcrumb: t('broker.createBroker'),
  },
  {
    path: '/visitors/log',
    breadcrumb: t('actions.log'),
  },
  {
    path: '/visitors/profile/:visitorId',
    breadcrumb: visitorBreadcrumbs,
  },
  {
    path: '/visitors/settings',
    breadcrumb: t('title.visitorSettings'),
  },
  {
    path: '/visitors',
    breadcrumb: t('title.visitorManagement'),
  },
  {
    path: '/access-cards/batches-list/:id',
    breadcrumb: accessCardBreadcrumbs,
  },
  {
    path: '/access-cards/batches-list',
    breadcrumb: t('title.accessCardBatches'),
  },
  { path: '/access-cards/list/:id', breadcrumb: accessCardBreadcrumbs },
  { path: '/access-cards/list', breadcrumb: t('title.accessCards') },
  {
    path: '/document-library',
    breadcrumb: t('title.documentLibrary'),
  },
  {
    path: '/notification-preferences',
    breadcrumb: t('title.notificationPreferences'),
  },
  {
    path: '/exports/sr',
    breadcrumb: t('title.serviceRequests'),
  },
  {
    path: '/exports/visitor-log',
    breadcrumb: t('title.visitorLog'),
  },
  {
    path: '/deliveries/management/:id',
    breadcrumb: deliveryTypesBreadcrumbs,
  },
  {
    path: '/deliveries/list',
    breadcrumb: t('delivery.deliveriesList'),
  },
  {
    path: '/deliveries/management',
    breadcrumb: t('delivery.deliveryTypesManagement'),
  },
  {
    path: '/amenity/management/info/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/amenity/management/:id',
    breadcrumb: amenityBreadcrumbs,
  },
  {
    path: '/amenity/reservations/:id',
    breadcrumb: amenityReservationBreadcrumbs,
  },
  { path: '/amenity', breadcrumb: t('title.amenityReservations') },
  {
    path: `${accessControlURL}/lyazon`,
    breadcrumb: t('provider.lyazon'),
  },
  {
    path: `${accessControlURL}/zerv`,
    breadcrumb: t('provider.zerv'),
  },
  {
    path: `${accessControlURL}/salto`,
    breadcrumb: t('provider.salto'),
  },
  {
    path: `${accessControlURL}/keyscan`,
    breadcrumb: t('provider.keyscan'),
  },
  {
    path: `${accessControlURL}`,
    breadcrumb: t('title.accessControl'),
  },
  {
    path: `${accessControlURL}/two_n`,
    breadcrumb: t('provider.two_n'),
  },
  {
    path: `${accessControlURL}/akuvox`,
    breadcrumb: t('provider.akuvox'),
  },
  {
    path: `${camerasURL}/eagle_eye`,
    breadcrumb: t('provider.eagleEye'),
  },
  {
    path: '/external-accounts-settings/:type/:account/update/:accountId',
    breadcrumb: externalAccountBreadcrumbs,
  },
  {
    path: '/external-accounts-settings/:type/:account/create',
    breadcrumb: t('actions.create'),
  },
  {
    path: '/external-accounts-settings/access-control-account/brivo/clear-users',
    breadcrumb: t('title.clearUsers'),
  },
  {
    path: '/external-accounts-settings/access-control-account/dormakaba',
    breadcrumb: t('provider.dormakaba'),
  },
  {
    path: '/external-accounts-settings/custom-integrations/external-links',
    breadcrumb: t('externalAccounts.externalLinks'),
  },
  {
    path: '/external-accounts-settings/custom-integrations',
    breadcrumb: t('title.customIntegrations'),
  },
  {
    path: '/external-accounts-settings/payment-account',
    breadcrumb: t('account.paymentAccount'),
  },
  {
    path: '/external-accounts-settings/camera-account',
    breadcrumb: t('account.cameraAccount'),
  },
  {
    path: '/external-accounts-settings',
    breadcrumb: t('title.externalAccounts'),
  },
  {
    path: '/camera-history',
    breadcrumb: t('camera.cameraHistory'),
  },
  {
    path: '/billing-report',
    breadcrumb: t('title.monthlyBill'),
  },
  {
    path: '/community',
    breadcrumb: t('title.community'),
  },
  {
    path: '/community/list/:id',
    breadcrumb: communityBreadcrumbs,
  },
  {
    path: '/community/content-approval',
    breadcrumb: t('title.contentApproval'),
  },
  {
    path: '/community/setup',
    breadcrumb: t('community.communitySetup'),
  },
  {
    path: '/remote-doorman/agents-list',
    breadcrumb: t('remoteDoorman.agentsList'),
  },
  {
    path: '/remote-doorman/agents-log',
    breadcrumb: t('remoteDoorman.agentsLog'),
  },
  {
    path: '/remote-doorman/agents-management',
    breadcrumb: t('remoteDoorman.agentManagement'),
  },
  {
    path: '/remote-doorman/calls',
    breadcrumb: t('remoteDoorman.callsLog'),
  },
  {
    path: '/remote-doorman/pop-ups',
    breadcrumb: t('remoteDoorman.buildingPopUps'),
  },
  {
    path: '/remote-doorman',
    breadcrumb: t('title.remoteDoorman'),
  },
  {
    path: '/terms-and-conditions',
    breadcrumb: t('footer.terms'),
  },
  {
    path: '/privacy-policy',
    breadcrumb: t('footer.privacy'),
  },
  {
    path: '/events',
    breadcrumb: t('title.events'),
  },
  {
    path: '/events/details/:id',
    breadcrumb: eventBreadcrumbs,
  },
  {
    path: '/events/details/:id/rsvps',
    breadcrumb: t('events.manageRsvps'),
  },
  {
    path: '/events/add',
    breadcrumb: t('events.add'),
  },
  {
    path: '/events/:id',
    breadcrumb: t('title.editEvent'),
  },
];

export const config = {
  excludePaths: [
    '/',
    '/pmc',
    '/building',
    '/pmc/:pmcId/staff/:personId/roles',
    '/pmc/:pmcId/visitors/manage',
    '/pmc/:pmcId/amenity/:type/info',
    '/pmc/:pmcId/amenity/:type',
    '/building/:buildingId/staff/:personId/roles',
    '/building/:buildingId/settings/:type',
    '/building/:buildingId/settings/:type/:provider',
    '/building/:buildingId/settings/:type/:provider/:id',
    '/building/:buildingId/visitors/manage',
    '/building/:buildingId/amenity/:type/info',
    '/building/:buildingId/amenity/:type',
    '/users',
    '/external-accounts-settings/:type/:account/update/',
    '/external-accounts-settings/access-control-account/brivo/clear-users/:accountId',
    '/visitors/manage/update-visitor',
    '/visitors/manage/update-broker',
    '/visitors/manage/update-prospective-tenant',
    '/visitors/manage',
    '/visitors/profile',
    '/visitors/update',
    '/visitors/list',
    '/messages/:id',
    '/pmc/:pmcId/messages/:id',
    '/building/:buildingId/messages/:id',
    '/access-cards',
    '/building/:buildingId/residents/create-in-unit',
    '/deliveries',
    '/amenity/:type/info',
    '/amenity/:type',
    '/amenity/reservations/list',
    '/amenity/reservations/calendar',
    '/pmc/:pmcId/amenity/reservations/list',
    '/pmc/:pmcId/amenity/reservations/calendar',
    '/building/:buildingId/amenity/reservations/list',
    '/building/:buildingId/amenity/reservations/calendar',
    '/building/:buildingId/settings/accounts/accounting-account/yardi/:id/',
    '/community/list',
    '/community/messages/:id',
    '/events/details/:id/lists',
    '/events/details/',
  ],
};
